export default __webpack_public_path__ + "assets/ea52466e0d771f316d2029bec00d1d5b.png";